import { Check, X, Ban } from "lucide-react";

const MultiUserEnable = ({
  isSelectionMode,
  setIsSelectionMode,
  selectedCount,
  onDisable,
  onCancel,
}) => {
  return (
    <div className="flex items-center gap-3 w-full justify-end">
      {!isSelectionMode ? (
        <button
          onClick={() => setIsSelectionMode(true)}
          className="flex items-center bg-white hover:bg-gray-100 text-gray-800 px-3 py-1.5 rounded-md border border-gray-300"
        >
          <span className="pr-2">Select Users</span>
          <Check size={18} />
        </button>
      ) : (
        <div className="flex items-center gap-2">
          <span className="text-gray-700 font-medium">
            {selectedCount} selected
          </span>
          <button
            onClick={onDisable}
            disabled={selectedCount === 0}
            className={`flex items-center px-3 py-1.5 rounded-md text-white ${
              selectedCount === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-teal-600 hover:bg-teal-500"
            }`}
          >
            <Ban size={16} className="mr-1" />
            Enable
          </button>
          <button
            onClick={onCancel}
            className="flex items-center bg-gray-100 hover:bg-gray-200 text-gray-800 px-3 py-1.5 rounded-md border border-gray-300"
          >
            <X size={16} className="mr-1" />
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default MultiUserEnable;
